import { DataGrid, useGridApiRef } from "@mui/x-data-grid";
import { CustomGridToolbar } from "./customized-toolbar/CustomGridToolbar";
import { GridApiCommunity } from "@mui/x-data-grid/models/api/gridApiCommunity";
import { formatUsersForTable, getColumns } from "./internals/data/gridData";
import CognitoUser from "../../../types/CognitoUser";

export default function CustomizedDataGrid({
  users,
  loading,
  handleEditClick,
  handleAddClick,
  handleDeactivateUserClick,
  handleDeleteUserClick,
}: {
  users: CognitoUser[];
  loading: boolean;
  handleEditClick: (user: any) => void;
  handleAddClick: () => void;
  handleDeactivateUserClick: (user: any) => void;
  handleDeleteUserClick: (user: any) => void;
}) {
  const apiRef = useGridApiRef<GridApiCommunity>();
  const columns = getColumns(
    handleEditClick,
    handleDeactivateUserClick,
    handleDeleteUserClick
  );

  const formattedUsersData = formatUsersForTable(users);

  return (
    <>
      <DataGrid
        checkboxSelection
        rows={formattedUsersData}
        columns={columns}
        loading={loading}
        getRowId={(row) => row.id}
        getRowClassName={(params) =>
          params.indexRelativeToCurrentPage % 2 === 0 ? "even" : "odd"
        }
        initialState={{
          pagination: { paginationModel: { pageSize: 20 } },
          density: "compact",
        }}
        pageSizeOptions={[10, 20, 50]}
        disableColumnResize
        apiRef={apiRef}
        slots={{
          toolbar: () => <CustomGridToolbar handleClickOpen={handleAddClick} />,
        }}
        slotProps={{
          filterPanel: {
            filterFormProps: {
              logicOperatorInputProps: {
                size: "small",
              },
              columnInputProps: {
                size: "small",
                sx: { mt: "auto" },
                inputProps: {
                  sx: { ml: "50px" },
                },
              },
              operatorInputProps: {
                size: "small",
                sx: { mt: "auto" },
              },
              valueInputProps: {
                InputComponentProps: {
                  size: "small",
                },
              },
            },
          },
        }}
      />
    </>
  );
}
